import _ from 'lodash'

const PAST_CLAMP_GRACE_MS = 60 * 1000

export const isSameCalendarDay = (a, b) => {
  if (!a || !b || !_.isDate(new Date(a)) || !_.isDate(new Date(b))) return false
  const d1 = new Date(a)
  const d2 = new Date(b)
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
}

export const startOfToday = () => {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  return d
}

export const endOfToday = () => {
  const d = new Date()
  d.setHours(23, 59, 0, 0)
  return d
}

/** Earliest selectable time in the time dropdown for the given calendar day */
export const getMinTimeForDate = selectedDate => {
  if (!selectedDate || !isSameCalendarDay(selectedDate, new Date())) {
    return startOfToday()
  }
  return new Date()
}

export const needsCompanyStartDateClamp = date => {
  if (!date || !_.isDate(date) || Number.isNaN(date.getTime())) return false
  return date.getTime() < Date.now() - PAST_CLAMP_GRACE_MS
}

/** If user picks today at midnight (or any past instant), bump to now */
export const clampCompanyBookingDateTime = date => {
  if (!date || !_.isDate(date) || Number.isNaN(date.getTime())) return date
  if (!needsCompanyStartDateClamp(date)) return date
  return new Date()
}

export const needsCompanyEndDateClamp = (endDate, startDate) => {
  if (!endDate || !startDate || !_.isDate(endDate) || !_.isDate(startDate)) return false
  const endMs = new Date(endDate).getTime()
  const startMs = new Date(startDate).getTime()
  return endMs <= startMs || endMs < Date.now() - PAST_CLAMP_GRACE_MS
}

/** Ensure end is strictly after start (add 30 minutes if not) */
export const clampCompanyBookingEndAfterStart = (endDate, startDate) => {
  if (!endDate || !startDate || !_.isDate(endDate) || !_.isDate(startDate)) return endDate
  const startMs = new Date(startDate).getTime()
  let end = new Date(endDate)
  if (end.getTime() <= startMs) {
    end = new Date(startMs + 30 * 60 * 1000)
  }
  if (end.getTime() < Date.now() - PAST_CLAMP_GRACE_MS) {
    return new Date(Math.max(startMs + 30 * 60 * 1000, Date.now()))
  }
  return end
}

/** When start is today, only allow future times */
export const filterBookingStartTime = (time, selectedStartDate) => {
  const now = new Date()
  const day = selectedStartDate ? new Date(selectedStartDate) : now
  day.setHours(0, 0, 0, 0)
  const today = startOfToday()
  if (day.getTime() > today.getTime()) return true
  const candidate = new Date(day)
  candidate.setHours(time.getHours(), time.getMinutes(), 0, 0)
  return candidate.getTime() >= now.getTime()
}

/** End time must be after start when on the same day */
export const filterBookingEndTime = (time, rentalStartDate, rentalEndDate) => {
  if (!rentalStartDate) return true
  const start = new Date(rentalStartDate)
  const endDay = rentalEndDate ? new Date(rentalEndDate) : start
  endDay.setHours(0, 0, 0, 0)
  start.setHours(0, 0, 0, 0)
  if (endDay.getTime() > start.getTime()) return true
  const candidate = new Date(endDay)
  candidate.setHours(time.getHours(), time.getMinutes(), 0, 0)
  return candidate.getTime() > new Date(rentalStartDate).getTime()
}

/** Company booking: datetime must not be before now (small grace for picker lag) */
export const isPastBookingDate = value => {
  if (!value || !_.isDate(value) || Number.isNaN(value.getTime())) return false
  return value.getTime() < Date.now() - 30 * 1000
}
